import { generateAvatarGraphics } from '@swf/poker';

import DefaultUserAvatarOne from '../assets/default-user-avatar-1.png';
import DefaultUserAvatarTwo from '../assets/default-user-avatar-2.png';
import DefaultUserAvatarThree from '../assets/default-user-avatar-3.png';
import DefaultUserAvatarFour from '../assets/default-user-avatar-4.png';
import DefaultUserAvatarFive from '../assets/default-user-avatar-5.png';

export const USER_DEFAULT_AVATARS = [
  DefaultUserAvatarOne,
  DefaultUserAvatarTwo,
  DefaultUserAvatarThree,
  DefaultUserAvatarFour,
  DefaultUserAvatarFive
];

export const getAvatarImage = (userId: string | undefined) => {
  if (!userId) {
    return '';
  }

  return generateAvatarGraphics(userId, USER_DEFAULT_AVATARS, 'image');
};
